<main>
  <loading-overlay [isLoading]="isLoading() > 0" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'InternalTransfer_Title' | translateWF: 'Internal Transfers' }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'InternalTransfer_New' | translateWF: 'New transfer'" icon="pi pi-plus" (click)="startNewTransfer()" />
        </div>
      </div>
      <small class="text-surface-500">
        {{ 'InternalTransfer_Subtitle' | translateWF: 'Money moved between two of our own bank accounts. A transfer starts from the account sending the funds.' }}
      </small>
    </div>

    <div class="grid-12 gap-[1.5rem]">
      <!-- The in-transit count is the point of this page: each one is money in a clearing account that
           nobody has yet said arrived. -->
      <div class="span-12 flex flex-wrap items-center gap-3">
        <p-tag severity="warn" [value]="inTransitCount() + ' ' + ('InternalTransfer_InTransit' | translateWF: 'in transit')" icon="pi pi-clock" />
        <p-tag severity="info" [value]="draftCount() + ' ' + ('InternalTransfer_Drafts' | translateWF: 'drafts')" icon="pi pi-file-edit" />

        <span class="p-input-icon-left grow max-w-[24rem]">
          <i class="pi pi-search"></i>
          <input
            pInputText
            [formControl]="searchControl"
            class="w-full"
            [placeholder]="'InternalTransfer_SearchPlaceholder' | translateWF: 'Search by number, account or cash request'"
          />
        </span>

        <div class="row-sm-start-center">
          <p-checkbox [formControl]="actionableOnlyControl" [binary]="true" inputId="actionableOnly" />
          <label for="actionableOnly" class="text-sm cursor-pointer">
            {{ 'InternalTransfer_ActionableOnly' | translateWF: 'Needs attention only' }}
          </label>
        </div>
      </div>

      <div class="span-12">
        <p-table [value]="filteredTransfers()" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]" [rowHover]="true" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'InternalTransfer_Table_Number' | translateWF: 'Number' }}</th>
              <th>{{ 'InternalTransfer_Table_From' | translateWF: 'From' }}</th>
              <th>{{ 'InternalTransfer_Table_To' | translateWF: 'To' }}</th>
              <th class="text-right">{{ 'InternalTransfer_Table_Sent' | translateWF: 'Sent' }}</th>
              <th class="text-right">{{ 'InternalTransfer_Table_Received' | translateWF: 'Received' }}</th>
              <th>{{ 'InternalTransfer_Table_Currency' | translateWF: 'Currency' }}</th>
              <th>{{ 'InternalTransfer_Table_Status' | translateWF: 'Status' }}</th>
              <th>{{ 'InternalTransfer_Table_SentDate' | translateWF: 'Sent date' }}</th>
              <th>{{ 'InternalTransfer_Table_CashRequest' | translateWF: 'Cash request' }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-transfer>
            <tr class="cursor-pointer" (click)="openTransfer(transfer)">
              <td>
                <a>{{ transfer.number }}</a>
              </td>
              <td>{{ transfer.fromAccountCode }}</td>
              <td>{{ transfer.toAccountCode }}</td>
              <td class="text-right">{{ transfer.amount | number: '1.2-2' }}</td>
              <td class="text-right">
                @if (receivedAmount(transfer) !== null) {
                  {{ receivedAmount(transfer) | number: '1.2-2' }}
                } @else {
                  <span class="text-surface-400">—</span>
                }
              </td>
              <td>{{ currencyLabel(transfer.currency) }}</td>
              <td>
                <p-tag [severity]="statusSeverity(transfer.status)" [value]="statusLabel(transfer.status)" />
              </td>
              <td>{{ transfer.transferDate | date: 'dd/MM/yyyy' }}</td>
              <td>
                @if (transfer.cashRequest?.number) {
                  {{ transfer.cashRequest.number }}
                } @else {
                  <span class="text-surface-400">—</span>
                }
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9" class="text-center text-surface-500">
                {{ 'InternalTransfer_Empty' | translateWF: 'No transfers match this filter' }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</main>
